import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import { ModalDirective, ModalOptions } from 'angular-bootstrap-md';
import { FilesService } from './../../../services/files.service';
import { Router } from '@angular/router';
import { environment } from './../../../../../environments/environment';

@Component({
  selector: 'modal-pedido',
  templateUrl: './pedido.component.html',
  styleUrls: ['./pedido.component.scss']
})
export class ModalPedidoComponent implements OnInit {
  @Input('pedido') item: any;
  @Input('rol') rol: string;
  @Input('type') type: string;
  @Input('type_estado') type_estado : string;
  @Output('update') update = new EventEmitter<boolean>();
  estado = false;
  env;
  @ViewChild('modal') modal: ModalDirective;
  modalConfigDefaults: ModalOptions = {
      backdrop: false,
      keyboard: false,
      focus: true,
      show: false,
      ignoreBackdropClick: true,
      class: '',
      animated: true
    };
    adjuntos: any;
  constructor(private fileService: FilesService, private router: Router) { 
    this.env = environment;
  }

  ngOnInit() {
    this.modal.config = this.modalConfigDefaults;
  }

  changeEstado(event: boolean){
    this.estado = event;
  }

  async openModal(elem){
    await this.getAdjuntos();
    elem.show();
  }

  async getAdjuntos(){
    this.fileService.getFiles(this.item.id).subscribe(adjuntos => this.adjuntos = adjuntos);
  }

  updateAdjuntos(event: boolean){
    if ( event ) this.getAdjuntos();
  }

  close(elem){
    elem.hide();
    this.output(false);
}

navigateLink(id){
  let url = environment.getFile;
  this.router.navigate([url,id]);
}

  output(event: boolean){
    if((!event && this.estado) || event){
      this.update.emit(true);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/modals/pedido/pedido.component.ts